import React from 'react'
import { Action } from '../../../constants/Common'
import { ucFirst } from '../../../helpers/string_helper'
import CreatorDetails from '../../../pages/ChangeRequest/activities/creatorDetails'
import { ActivityModule, Modules } from '../../../constants/Module'
import { withTranslation } from 'react-i18next'
function DocumentAssociation({ item, t }) {
  return (
    <div><strong>{t('Document')} ({item?.payload?.document?.name})</strong> {t('was associated with the')} <strong>{item.payload.module === 'item' ? 'agenda item' : item?.payload?.module === Modules.PROJECT_DELIVERABLE ? 'deliverable' : item.payload.module} {item?.payload?.module !== Modules.PROJECT_DELIVERABLE && (
      <>
        {item.payload.module === 'item'
          ? ucFirst(item.payload.moduleDetails?.description)
          : ucFirst(item.payload.moduleDetails?.name)}
        {item.payload.module === ActivityModule.PROJECT && ` | ${item?.project?.uniqueProjectId}`}
      </>
    )}</strong>
      {item?.payload?.module === Modules.PROJECT_DELIVERABLE && (
        <>
          under startup <strong>{item.project.name} ({item.project.uniqueProjectId})</strong>
        </>
      )}
      {' '}{t('by')}
      <CreatorDetails creator={item?.creator} date={item?.createdAt} /></div>
  )
}
export default withTranslation()(DocumentAssociation)
